<template>
  <div>
    <div class="header-img-div" style="position: absolute; top: 0; left: 0; width: 100%; height: 300px; overflow: hidden;">
      <picture>
        <source :srcset="require('../assets/images/home-1080.webp')" media="(min-width: 721px)" />
        <source :srcset="require('../assets/images/home-720.webp')" media="(min-width: 413px)" />
        <img :src="require('../assets/images/home-412.webp')" style="width: 100%;" alt="Paisaje agrícola" />
      </picture>
    </div>
    <div>
      <section class="title-text-section section section-lg pb-0 pb-sm-5 pt-4 mx-2 lg-mx-3">
        <div class="container mw-100">
          <div class="row justify-content-center mx-10">
            <h1 class="home-title text-center" style="color: #fff; font-size: 32px">
              Descubre la forma más fácil de alquilar tu lote
            </h1>
          </div>
          <div class="row justify-content-center mt-4 mx-0">
            <h2 class="home-subtitle text-center" style="color: #fff; font-size: 20px;">
              La primera plataforma inteligente que conecta propietarios con productores, maximizando el potencial de tu campo.
            </h2>
          </div>
        </div>
      </section>
      <section class="section section-lg pb-5 md-mx-5" :class="isSmallView ? 'pt-1' : 'pt-6'">
        <div class="px-0">
          <div class="row mx-0">
            <div class="col-12 col-md-6 px-3 py-3">
              <div class="col-12 col-lg-8 offset-lg-2">
                <card class="border-0" shadow body-classes="py-4" style="height: 100%; overflow: auto;">
                  <div id="publish-form"></div>
                </card>
              </div>
            </div>
            <div class="secondary-features col-12 col-sm-6 col-lg-5 py-3 px-5 pl-md-0 pr-md-5">
              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <div class="div-icon bg-white text-center mb-3">
                    <i class="icon fa fa-usd"></i>
                  </div>
                  <p class="title"><strong>Potencia tus ingresos sin costo</strong></p>
                  <p class="subtitle">Mejoramos tus ofertas previas y te ayudamos a alquilar tu lote por lo que realmente vale. No pagarás ninguna comisión ni suscripción por ofrecer tu lote.</p>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <div class="div-icon bg-white text-center mb-3">
                    <i class="icon fa fa-heartbeat"></i>
                  </div>
                  <p class="title"><strong>Cuidamos tu campo</strong></p>
                  <p class="subtitle">Supervisamos periódicamente el lote, registrando las actividades que se realizan y asegurando el cuidado del mismo.</p>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <div class="div-icon bg-white text-center mb-3">
                    <i class="icon fa fa-check"></i>
                  </div>
                  <p class="title"><strong>Destaca tus lotes</strong></p>
                  <p class="subtitle">LotePerfecto funciona como un sello de calidad que valoriza tu propiedad. Registramos todas las aplicaciones de agroquímicos, cultivos y labores en tus lotes para generar un historial confiable.</p>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <div class="div-icon bg-white text-center mb-3">
                    <i class="icon fa fa-star"></i>
                  </div>
                  <p class="title"><strong>Scoring de productores</strong></p>
                  <p class="subtitle">Cuando recibas una oferta, accederás al historial del productor interesado para saber cómo han sido sus experiencias de alquiler pasadas.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section section-lg pb-5 pt-3 mx-5">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3 px-3 py-3" v-for="(review, index) in reviews" :key="index">
            <card shadow class="card-profile" hover no-body style="height: 540px;">
              <div class="full-width" :style="`position: absolute; width: 100%; height: 6rem; background-color: ${review.color}`"></div>
              <div class="px-4">
                <div class="row justify-content-center">
                  <div class="card-profile-image text-center pt-3" style="max-height: 200px; z-index: 1;">
                    <img :src="review.img" :alt="`Opinión de ${review.name}`" class="rounded-circle mw-100 h-100">
                  </div>
                </div>
                <div class="text-center mt-3">
                  <h3 class="mb-0" style="color: #545454">{{review.name}}</h3>
                  <div class="h6 font-weight-300" style="color: #545454">{{review.role}}</div>
                </div>
                <div class="py-3 text-center">
                  <div class="row justify-content-center">
                    <div class="col">
                      <p style="color: #545454"><i>{{review.review}}</i></p>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </section>
      <section class="section section-lg pt-0 mt-md-12 pb-5">
        <div class="container" style="max-width: 100%">
          <div class="row row-grid justify-content-center">
            <div class="col-8">
              <card class="border-0" shadow body-classes="pt-4">
                <div class="row justify-content-center">
                  <div class="col-lg-10 text-center align-items-center">
                    <h4 class="text-center">
                      Estás a un click de publicar tu lote. Sin comisiones ni gastos adicionales
                    </h4>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-lg-4 text-center align-items-center">
                    <base-button block type="secondary" style="background-color: #4E9306; color: white; font-size: 20px;" class="hs-cta-trigger-button hs-cta-trigger-button-122552871731">Publicar</base-button>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Modal from '../components/Modal'
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  name: "publish",
  components: {
    flatPicker,
    Modal,
    CloseButton,
    BaseDropdown
  },
  data() {
    return {
      reviews: [
        {
          name: 'José',
          role: 'Tupungato, Mendoza',
          review: 'Gracias a LotePerfecto, pude realizar un seguimiento detallado de lo que sucedió en mi campo durante el período de arrendamiento.',
          img: require('../assets/images/profile-jose.webp'),
          color: '#4E9306'
        },
        {
          name: 'Emilio',
          role: 'La Carlota, Córdoba',
          review: 'El historial de cultivos que obtuve a través de la plataforma fue una herramienta invaluable. Me permitió planificar mejor las rotaciones de cultivos en mi campo, maximizando su productividad.',
          img: require('../assets/images/profile-emilio.webp'),
          color: '#E5A20A'
        },
        {
          name: 'María',
          role: 'Venado Tuerto, Santa Fe',
          review: 'El seguimiento detallado y los registros históricos de la plataforma me brindaron tranquilidad y confianza en la gestión de mi propiedad.',
          img: require('../assets/images/profile-maria.webp'),
          color: '#4E9306'
        },
        {
          name: 'Oscar',
          role: 'Pergamino, Buenos Aires',
          review: 'La plataforma me brindó un historial completo de los agroquímicos aplicados, lo cual me ayudó a garantizar prácticas agrícolas sostenibles y seguras para el medio ambiente  .',
          img: require('../assets/images/profile-oscar.webp'),
          color: '#E5A20A'
        }
      ]
    }
  },
  mounted() {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'pageview',
        'page_location': '/',
        'page_title': 'Publish'
    });
    let publishForm = document.createElement('script')
      publishForm.textContent = `
      hbspt.forms.create({
        region: 'na1',
        portalId: '5093095',
        formId: 'bc3a665f-cc87-4950-9077-893a5075b30c'
      })`;
      document.getElementById('publish-form').appendChild(publishForm);
  },
  computed: {
    isSmallView () {
      return window.innerWidth <= 768
    }
  }
};
</script>
